import { IGetUIProfileConfigParams } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { web3Api } from 'store/queries';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';

import { IUserProfileConfig } from '../types';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be refelected there as well.
export const {
  endpoints: { getUIProfileConfig },
  useGetUIProfileConfigQuery,
  useLazyGetUIProfileConfigQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    getUIProfileConfig: build.query<
      IUserProfileConfig,
      IGetUIProfileConfigParams
    >({
      queryFn: createQueryFnWithErrorHandler({
        queryFn: async params => {
          const service = MultiService.getService();

          const data = await service
            .getAccountingGateway()
            .getUIProfileConfig(params);

          return {
            data: data?.ui_config
              ? (JSON.parse(data?.ui_config) as IUserProfileConfig)
              : {},
          };
        },
      }),
    }),
  }),
});

export const {
  selectDataCachedByParams: selectUIProfileConfig,
  selectLoadingCachedByParams: selectUIProfileConfigLoading,
  selectStateCachedByParams: selectUIProfileConfigState,
} = createQuerySelectors({ endpoint: getUIProfileConfig });
